import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import FormFieldLabelTooltip from '../FormFieldLabelTooltip';
import styles from './styles.scss';

const propTypes = {
  className: PropTypes.string,
  description: PropTypes.string,
  htmlFor: PropTypes.string.isRequired,
  inline: PropTypes.bool,
  required: PropTypes.bool,
  title: PropTypes.string.isRequired,
  tooltip: PropTypes.string,
  placement: PropTypes.string,
};

const defaultProps = {
  className: undefined,
  description: undefined,
  inline: undefined,
  required: undefined,
  tooltip: undefined,
  placement: undefined,
};

const FormFieldLabel = ({
  className,
  description,
  htmlFor,
  inline,
  required,
  title,
  tooltip,
  placement,
}) => {
  const classes = cx(
    styles.label,
    inline && styles.inline,
    required && styles.required,
    className,
  );

  return (
    <label htmlFor={htmlFor} className={classes}>
      <span className={styles.content}>
        <span className={styles.title}>
          <span className={styles.text}>
            {title}
          </span>
          {tooltip && (
            <FormFieldLabelTooltip
              className={styles.tooltip}
              text={tooltip}
              placement={placement}
            />
          )}
        </span>
        {description && (
          <span className={styles.description}>
            {description}
          </span>
        )}
      </span>
    </label>
  );
};

FormFieldLabel.propTypes = propTypes;
FormFieldLabel.defaultProps = defaultProps;

export default FormFieldLabel;
